module.exports = __webpack_public_path__ + "static/media/checklist-color.e9937484.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/get-started/checklist-color.png
// module id = 1533
// module chunks = 3